import { classNames } from 'lib/utils/classnames'
import React, { FunctionComponent } from 'react'

interface IStepProps {
  number: string
  title: string
  optional?: boolean
}

const Step: FunctionComponent<IStepProps> = ({ number, title, optional = false }): JSX.Element => {
  return (
    <div className="step flex items-center py-4">
      <div
        className={classNames(
          'flex items-center justify-center border-2 border-gray-300 p-1 font-bold dark:border-gray-700 rounded-full h-8 w-8',
          optional ? 'text-orange-500' : 'text-secondary-500'
        )}
      >
        {number}
      </div>
      <h3 className="ml-3 tracking-tight font-bold">{title}</h3>
    </div>
  )
}

export default Step
